import type { SVGProps } from "react";
const SenecPictogramChevronRight = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M16.273 6.31338C16.6522 5.91186 17.2851 5.89378 17.6866 6.27299L36.4564 24L17.6866 41.727C17.2851 42.1062 16.6522 42.0881 16.273 41.6866C15.8938 41.2851 15.9119 40.6522 16.3134 40.273L33.5436 24L16.3134 7.72702C15.9119 7.3478 15.8938 6.7149 16.273 6.31338Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramChevronRight;
